import { isInternalBuild } from '@theia-lved-core/common/build-env';
import { FrontendApplicationContribution } from '@theia/core/lib/browser';
import { ILogger, LogLevel } from '@theia/core/lib/common/logger';
import { inject, injectable } from '@theia/core/shared/inversify';

@injectable()
export class FrontendLogLevelContribution implements FrontendApplicationContribution {
    @inject(ILogger)
    protected readonly logger!: ILogger;

    async configure(): Promise<void> {
        const logLevel = isInternalBuild() ? LogLevel.DEBUG : LogLevel.INFO;
        console.log(`[FrontendLogLevelContribution] logLevel=${logLevel}`);
        await this.logger.setLogLevel(logLevel);
    }
}
